module.exports = __webpack_public_path__ + "static/media/concombres.1ca5b810.svg";